import React from "react";
import { Link } from "react-router-dom";
import "../../src/assets/stylesheets/Footer.css";
import { useBrand } from "../branding/BrandContext";

export default function Footer() {
  const brand = useBrand();

  return (
    <footer className="siteFooter">
      <div className="footerInner">
        <div className="footerLeft">
          <div className="footerLogo">
            {brand.brandName}
            <sup className="regtrade">TM</sup>
            <span className="brand_small">.com</span>
          </div>

          <div className="footerTagline">{brand.consumerByline}</div>

          <nav className="footerNav">
            <Link to="/terms">Terms Of Use</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/faqs">FAQs</Link>
            <Link to="/do-not-sell">Do Not Sell</Link>
            <a
              href={brand.contractorBaseUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="I'm a contractor"
            >
              I’m a contractor
            </a>
          </nav>
        </div>

        <div className="footerRight">
          <img
            src="/assets/jim-pam-footer.png"
            alt=""
            className="footerMascot"
            draggable="false"
          />
        </div>
      </div>

      <div className="footerBottom">
        <div className="footerSocial">
          <a href="https://www.facebook.com/homehelper.biz" target="_blank" rel="noopener noreferrer" aria-label="Facebook">f</a>
          <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Instagram">◎</a>
          <a href="#" target="_blank" rel="noopener noreferrer" aria-label="TikTok">♪</a>
          <a href="https://www.linkedin.com/company/homehelper" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">in</a>
        </div>

        <div className="footerCopyright">
          © {new Date().getFullYear()} {brand.copyrightName}
          . All rights reserved.
        </div>
      </div>
    </footer>
  );
}
 
